
import { tagableMixin, campaignMixin } from "~/mixins";
import plpCampaignPricingMixin from "~/mixins/plpCampaignPricingMixin";

export default {
  mixins: [tagableMixin, campaignMixin, plpCampaignPricingMixin],

  props: {
    product: { type: Object, required: true },
    selectedVariant: { type: Object, required: true },
    minPriceVariant: { type: Object, default: () => ({}) },
    maxPriceVariant: { type: Object, default: () => ({}) },
    sizeFilterType: { type: String, default: "none" },
    isPlp: { type: Boolean, default: false },
  },

  computed: {
    price() {
      return this.minPriceVariant?.price ?? 0;
    },
    compareAtPrice() {
      return this.minPriceVariant?.compareAtPrice ?? 0;
    },
    minNow() {
      return Number(this.minPriceVariant?.price ?? 0);
    },
    maxNow() {
      return Number(this.maxPriceVariant?.price ?? 0);
    },
    minWas() {
      return Number(this.minPriceVariant?.compareAtPrice ?? 0);
    },
    maxWas() {
      return Number(this.maxPriceVariant?.compareAtPrice ?? 0);
    },
    saleTagText() {
      return this.priorityCampaign.value?.saleTileTitle ?? "";
    },
    saleTagTextMobile() {
      return this.priorityCampaign.value?.saleTileTitleMobile;
    },
    saleTagBgColor() {
      return this.priorityCampaign.value?.saleColor ?? "";
    },
    rrpValue() {
      return this.minWas > this.minNow ? this.minWas : this.minNow;
    },

    hasRrp() {
      return Number(this.rrpValue) > 0;
    },

    isSale() {
      return this.minWas > this.minNow;
    },

    showSellingPrice() {
      // Never show selling price for campaigns
      if (this.hasPlpCampaign) return false;

      // Only show selling price when it's actually discounted
      return this.isSale;
    },

    showRrp() {
      if (this.isIntroPriceCampaign) return false;

      // RRP is ALWAYS shown for campaigns
      if (this.hasPlpCampaign) return true;

      // Otherwise show if RRP exists
      return this.hasRrp;
    },

    rrpNeedsStrike() {
      return !this.hasPlpCampaign && this.isSale;
    },
  },
};
